import React, { useContext } from "react";
import UserContext from "contexts/UserContext";
import getRelatedArticles from "utils/ContentfulApi/getRelatedArticles";
import Head from "next/head";
import { NextSeo } from "next-seo";
import Container from "react-bootstrap/Container";

import Post from "components/Post";
import ContentfulApi from "@utils/ContentfulApi";
import { getArticleCardHref } from "utils/helpers";

export default function canonicalUrl(props) {
	const {
		post,
		// childTags,
		relatedArticles,
	} = props;
	const bannerImage = post?.fields?.bannerImage?.fields?.file?.url
		? `https:${post?.fields.bannerImage?.fields?.file?.url}`
		: "https://images.ctfassets.net/mdag2z2o3c18/73533DQHZgyUDdrQ0j4iwo/d2ac1fd3ae5f15103e3ce6f107e3d7cb/aapl-logo.png";

	return (
		<>
			<NextSeo
				title={`${post.fields.title} | AAPL Publication`}
				description={post.fields.summary || post.fields.abstract}
				openGraph={{
					images: [
						{
							url: bannerImage,
						},
					],
					url: `${process.env.WEB_URL}${getArticleCardHref(post.fields)}`,
					title: post.fields.title,
					description: post.fields.summary || post.fields.abstract,
				}}
			/>
			<Head>
				<meta property="twitter:title" content={post.fields.title} />
				<meta name="twitter:image" content={bannerImage} />
				<meta name="twitter:description" content={post.fields.summary || post.fields.abstract} />
			</Head>
			<Container fluid className="">
				<Post
					post={post}
					//  childTags={childTags}
					relatedArticles={relatedArticles}
				/>
				<style global jsx>{`
					body {
						background-color: white;
					}
				`}</style>
			</Container>
		</>
	);
}

// export async function getStaticPaths() {
// 	const ArticleSlugs = await ContentfulApi.getAllArticleSlugs();

// 	const paths = ArticleSlugs.map((articleSlug) => {
// 		const canonicalUrl = articleSlug.canonicalUrl;
// 		return { params: { canonicalUrl } };
// 	});

// 	return {
// 		paths,
// 		fallback: "blocking",
// 	};
// }

// export async function getStaticProps({ params }) {
// 	const post = await ContentfulApi.getBasicArticleBySlug(params.canonicalUrl);

// 	//some articles maybe published, BUT publication date is
// 	//in the future, show 404 if this is the case
// 	const now = new Date().getTime();
// 	const notYetPublished = !post?.fields?.publicationDate
// 		? true
// 		: now < new Date(post.fields.publicationDate).getTime()
// 		? true
// 		: false;

// 	if (!post || notYetPublished) {
// 		return {
// 			notFound: true,
// 			...(process.env.REVALIDATE_TIMER && { revalidate: process.env.REVALIDATE_TIMER }),
// 		};
// 	}

// 	//check if has DOI
// 	if (post?.fields?.doiPrefix && post?.fields?.doiSuffix) {
// 		return {
// 			redirect: {
// 				destination: getArticleCardHref(post.fields),
// 			},
// 		};
// 	}

// 	//get child tags
// 	let childTags = [];
// 	let relatedArticles = await getRelatedArticles(post);

// 	return {
// 		props: {
// 			post,

// 			relatedArticles,
// 		},
// 		...(process.env.REVALIDATE_TIMER && { revalidate: process.env.REVALIDATE_TIMER }),
// 	};
// }

// Remove getStaticPaths entirely since we won't be pre-building paths

// Replace getStaticProps with getServerSideProps
export async function getServerSideProps({ params, res }) {
	const post = await ContentfulApi.getBasicArticleBySlug(params.canonicalUrl);

	// Cache the response if desired (optional)
	// This will cache the page for the specified number of seconds
	if (process.env.REVALIDATE_TIMER) {
		res.setHeader("Cache-Control", `s-maxage=${10}, stale-while-revalidate`);
	}

	//some articles maybe published, BUT publication date is
	//in the future, show 404 if this is the case
	const now = new Date().getTime();
	const notYetPublished = !post?.fields?.publicationDate
		? true
		: now < new Date(post.fields.publicationDate).getTime()
		? true
		: false;

	if (!post || notYetPublished) {
		return {
			notFound: true,
		};
	}

	//check if has DOI
	if (post?.fields?.doiPrefix && post?.fields?.doiSuffix) {
		return {
			redirect: {
				destination: getArticleCardHref(post.fields),
				permanent: false, // Set to true if this is a permanent redirect
			},
		};
	}

	let relatedArticles = await getRelatedArticles(post);

	return {
		props: {
			post,
			relatedArticles,
		},
	};
}
